import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bc29db8c")

_pushScopeId("data-v-bc29db8c")
const _hoisted_1 = {
  key: 0,
  class: "panel internal-comments-panel"
}
const _hoisted_2 = { class: "panel-heading is-flex" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "label internal-comment-label" }, "Internal Comments", -1)
const _hoisted_4 = {
  class: "buttons",
  style: {"margin-left":"auto"}
}
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus-circle" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "pl-2" }, "Add", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "fas fa-sd-card" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "pl-2" }, "Save", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fas fa-undo" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "pl-2" }, "Cancel", -1)
const _hoisted_11 = {
  key: 1,
  class: "notification"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.isInternalCommentVisible)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            (!_ctx.isEditing && !_ctx.isRegActive)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  type: "button",
                  class: "button is-small is-rounded is-outlined",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modifyNote()))
                }, [
                  _hoisted_5,
                  _hoisted_6
                ]))
              : _createCommentVNode("", true),
            (_ctx.isEditing)
              ? (_openBlock(), _createBlock("button", {
                  key: 1,
                  disabled: _ctx.isLoading,
                  type: "button",
                  class: "button is-dark is-small is-rounded",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createNote()))
                }, [
                  _hoisted_7,
                  _hoisted_8
                ], 8, ["disabled"]))
              : _createCommentVNode("", true),
            (_ctx.isEditing)
              ? (_openBlock(), _createBlock("button", {
                  key: 2,
                  type: "button",
                  disabled: _ctx.isLoading,
                  class: "button is-small is-rounded is-outlined",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cancelEditing()))
                }, [
                  _hoisted_9,
                  _hoisted_10
                ], 8, ["disabled"]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.isEditing)
          ? _withDirectives((_openBlock(), _createBlock("textarea", {
              key: 0,
              class: "internal-comments-text-area panel-block",
              ref: "internalComments",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.internalNote.note = $event)),
              name: "comments"
            }, null, 512)), [
              [_vModelText, _ctx.internalNote.note]
            ])
          : _createCommentVNode("", true),
        (_ctx.anyExistingNotes)
          ? (_openBlock(), _createBlock("div", _hoisted_11, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.existingNotes, (note) => {
                return (_openBlock(), _createBlock("p", {
                  key: note.id,
                  style: {"white-space":"pre-wrap"}
                }, _toDisplayString(note.fullNote), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
})